import TextareaQuestionSurface from "./TextareaQuestionSurface";

export const SURFACE_11_LABEL = "How would you describe their personality?";
export const SURFACE_11_PLACEHOLDER = "Like you're telling a friend about them. Honest, not polished.";
export const SURFACE_11_ERROR = "A sentence is plenty.";

export default function Surface11(props) {
  return (
    <TextareaQuestionSurface
      current={7}
      label={SURFACE_11_LABEL}
      placeholder={SURFACE_11_PLACEHOLDER}
      errorCopy={SURFACE_11_ERROR}
      name="recipient_personality"
      {...props}
    />
  );
}
